import "./App.css";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./router";

// MUI X pickers imports
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import HttpClient from "./Screen/redux/api/HttpClient";
import Loader from "./Component/Loader";

function App() {
  const [loading, setLoading] = useState(false);

  const queryClient = new QueryClient();
  const token = localStorage.getItem("token");

  // console.log("token", token);

  useEffect(() => {
    if (token) {
      HttpClient.defaults.headers.common["Authorization"] =
        `Bearer ${token}` || "";
    }

    HttpClient.interceptors.request.use(
      function (config) {
        // spinning start to show
        setLoading(true);
        return config;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    HttpClient.interceptors.response.use(
      function (response) {
        // spinning hide
        setLoading(false);
        return response;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {loading && <Loader />}
        <AppRoutes />
      </LocalizationProvider>
    </QueryClientProvider>
  );
}

export default App;
